import { ReloadOutlined, ToolOutlined } from '@ant-design/icons';
import { Button, Layout, PageHeader, Table, Typography } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { SystemSetting } from '../../../models';
import { apiClient, apiErrorMessage, hasPermission } from '../../../utils';
import { UserContext } from '../../contexts';

export function SystemSettingsPage() {
  const { Content } = Layout;
  const { Text } = Typography;

  const { user } = useContext(UserContext);

  const [loading, setLoading] = useState(false);
  const [systemSettings, setSystemSettings] = useState<(SystemSetting & { key: string })[]>();
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    loadSystemSettings();
  }, []);

  useEffect(() => {
    setCanEdit(hasPermission(user, 'systemSettings.edit'));
  }, [user]);

  const loadSystemSettings = () => {
    setLoading(true);
    apiClient
      .get('system-settings')
      .then(response => {
        const responseSettings: SystemSetting[] = response.data;
        const responseData = responseSettings.map(systemSetting => {
          return {
            key: systemSetting.id,
            ...systemSetting,
          };
        });
        setSystemSettings(responseData);
        setLoading(false);
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  };

  const onValueChange = (id: string) => (newValue: string) => {
    setLoading(true);
    apiClient
      .put(`system-settings/${id}`, { value: newValue })
      .then(() => {
        setLoading(false);
        loadSystemSettings();
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  };

  const onRefreshClick = () => {
    loadSystemSettings();
  };

  const tableColumns = [
    {
      title: 'İsim',
      dataIndex: 'id',
      key: 'name',
    },
    {
      title: 'Açıklama',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Değer',
      dataIndex: 'value',
      key: 'value',
      render: (value: string, systemSetting: SystemSetting) => (
        <div style={{ width: '20rem' }}>
          <Text editable={canEdit && { onChange: onValueChange(systemSetting.id) }}>{value}</Text>
        </div>
      ),
    },
  ];

  return (
    <>
      <PageHeader
        title={
          <>
            <ToolOutlined /> Sistem ayarları
          </>
        }
        extra={[
          <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
            Yenile
          </Button>,
        ]}
      />
      <Content>
        <Table columns={tableColumns} dataSource={systemSettings} loading={loading} pagination={false} />
      </Content>
    </>
  );
}
